import { Code, Mail } from "lucide-react"
import { FaGithub } from "react-icons/fa"
import HTML5 from "@/assets/img/HTML5.svg";
import CSS3 from "@/assets/img/CSS3.svg";
import Bootstrap from "@/assets/img/Bootstrap.svg";
import React from "@/assets/img/React.svg";
import Jest from "@/assets/img/Jest.svg";
import Figma from "@/assets/img/Figma.svg";
import jQuery from "@/assets/img/jQuery.svg";
import nginx from "@/assets/img/NGINX.svg";
import webpack from "@/assets/img/Webpack.svg";
import tailwind from "@/assets/img/Tailwind CSS.svg";
import Go from "@/assets/img/Go.svg";
import Git from "@/assets/img/Git.svg";
import GithubAction from "@/assets/img/GitHub Actions.svg";
import NodeJS from "@/assets/img/Node.js.svg";
import Typescript from "@/assets/img/TypeScript.svg";
import Redis from "@/assets/img/Redis.svg";
import Postman from "@/assets/img/Postman.svg";
import Docker from "@/assets/img/Docker.svg";
import AWS from "@/assets/img/AWS.svg";
import k8s from "@/assets/img/Kubernetes.svg";
import MongoDB from "@/assets/img/MongoDB.svg";
import PostgreSQL from "@/assets/img/PostgresSQL.svg";
import Jenkins from "@/assets/img/Jenkins.svg";
import npm from "@/assets/img/NPM.svg";
import Express from "@/assets/img/Express.svg";
import GraphQL from "@/assets/img/GraphQL.svg";
import Yarn from "@/assets/img/Yarn.svg";

export const SKILLS = [
    { name: "React", level: 80 },
    { name: "Node.js", level: 80 },
    { name: "TypeScript", level: 80 },
    { name: "Tailwind CSS", level: 90 },
    { name: "Golang", level: 65 },
]

export const CONTACT_INFO = [
    { icon: Mail, label: "Email", value: "warrenquocbui@gmail.com" },
    { icon: FaGithub, label: "GitHub", value: "https://www.linkedin.com/in/quoc-bui-368515163" },
    { icon: Code, label: "Website", value: "https://quocbui.me" },
]

export const SOCIAL_LINKS = [
    { name: "github", href: "https://github.com/quocbui0607" },
    { name: "linkedin", href: "https://www.linkedin.com/in/quoc-bui-368515163" },
]

export const FRONT_END = [
    {
        name: "HTML5",
        src: HTML5,
    },
    {
        name: "CSS3",
        src: CSS3,
    },
    {
        name: "Bootstrap",
        src: Bootstrap,
    },
    {
        name: "jQuery",
        src: jQuery,
    },
    {
        name: "React",
        src: React,
    },
    {
        name: "Tailwind",
        src: tailwind,
    },
    {
        name: "Jest",
        src: Jest,
    },
    {
        name: "Figma",
        src: Figma,
    },
    {
        name: "nginx",
        src: nginx,
    },
    {
        name: "webpack",
        src: webpack,
    },
];

export const BACKEND = [
    {
        name: "NodeJS",
        src: NodeJS,
    },
    {
        name: "Typescript",
        src: Typescript,
    },
    {
        name: "Express",
        src: Express,
    },
    {
        name: "npm",
        src: npm,
    },
    {
        name: "yarn",
        src: Yarn,
    },
    {
        name: "GraphQL",
        src: GraphQL,
    },
    {
        name: "Go",
        src: Go,
    },
    {
        name: "Postman",
        src: Postman,
    },
    {
        name: "Git",
        src: Git,
    },
    {
        name: "Github Actions",
        src: GithubAction,
    },
    {
        name: "Jenkins",
        src: Jenkins,
    },
    {
        name: "Redis",
        src: Redis,
    },
    {
        name: "MongoDB",
        src: MongoDB,
    },
    {
        name: "PostgreSQL",
        src: PostgreSQL,
    },
    {
        name: "AWS",
        src: AWS,
    },
    {
        name: "Docker",
        src: Docker,
    },
    {
        name: "Kubernetes",
        src: k8s,
    },

];

export const CV_URL = "https://raw.githubusercontent.com/quocbui0607/quocbui0607/refs/heads/main/Quoc%20Bui%20CV.pdf"

export const PROJECTS = [
    {
        title: "National Australia bank",
        description: "A banking website integrated with Internal APIs built with modern technologies.",
        tags: ["NodeJS", "ReactJS", "Redis", "Docker", "Kubernetes"],
        image: "/img/NAB.jpg",
    },
    {
        title: "AnZ Banking",
        description: "Build new services with Golang for internal usings, integrated with Salesforce API",
        tags: ["Golang", "GCP ", "Docker", "Terraform", "Monorepo"],
        image: "/img/AnZ.jpg",
    }
]